import styled from 'styled-components';

export const WidthModifier = styled.span`
  max-width: ${({ maxW }) => maxW || '800px'};
  text-align: center;
  * {
    text-align: center;
  }
`;
